import { Branding } from '../../branding.interface';

export const MTIBA_BRANDING: Branding = {
  termsAndConditionsURL: 'https://mtiba.com/terms',
  privacyStatementURL: 'https://mtiba.com/privacy-policy',
  pageTitle: 'M-TIBA Member | Powered by CarePay',
  support: 'freshdesk',
  supportFreshworksURL: 'https://widget.freshworks.com/widgets',
  supportFreshdeskFormId: 35000000625,
  supportFreshdeskWidgetId: 35000001954,
  healthTab: false,
  heidiProviderTab: false,
  providersTab: true,
  freshchat: false,
  bankCodesUrl: 'https://www.kba.co.ke/wp-content/uploads/2023/09/Bank-and-Branches-July-2023v.pdf',
  poweredBySvg: 'carepay-logo.svg',
};
